import { BeneficioApi as Api } from "./beneficio.api";
import { ComercioFacade } from "../comercio/comercio.facade";
import Swal from "sweetalert2";

export class BeneficioFacade {
  static countWithFilter({
    busqueda = undefined,
    idComercio = undefined,
    subcategoria = undefined,
    estado = undefined
  }) {
    const filterDto = {
      busqueda,
      idComercio,
      subcategoria,
      estado: estado
    };

    return Api.countWithFilter(filterDto);
  }

  static countUsaCodigosWithFilter({
    busqueda = undefined,
    idComercio = undefined,
    subcategoria = undefined,
    estado = undefined
  }) {
    const filterDto = {
      busqueda,
      idComercio,
      subcategoria,
      estado: estado
    };

    return Api.countUsaCodigosWithFilter(filterDto);
  }

  static create(data) {
    return Api.create(data);
  }

  static deleteById(id) {
    return Api.deleteById(id);
  }

  static getListWithFilter({
    desde = 1,
    hasta = 20,
    busqueda = undefined,
    idComercio = undefined,
    subcategoria = undefined,
    estado = undefined
  }) {
    const filterDto = {
      busqueda,
      desde,
      hasta,
      idComercio,
      subcategoria,
      estado: estado
    };

    return Api.getListWithFilter(filterDto);
  }

  static getListUsaCodigosWithFilter({
    desde = 1,
    hasta = 20,
    busqueda
  }) {
    const filterDto = {
      desde,
      hasta,
      busqueda
    };


    return Api.getListUsaCodigosWithFilter(filterDto);
  }

  static getMinimumDiscountPercentageByComercioId(comercioId) {
    return ComercioFacade.getMinimumDiscountPercentageByComercioId(comercioId);
  }

  static getTipoDescuentoList() {
    return Api.getTipoDescuentoList();
  }

  static getUnidadesDescuentoList() {
    return Api.getUnidadesDescuentoList();
  }


  static update(data) {
    return Api.update(data);
  }

  static uploadLogo(beneficioId, formData) {
    return Api.uploadLogo(beneficioId, formData);
  }

  static getTiposCodigo() {
    return Api.getTiposCodigo();
  }

  static getCsvCodigos(body, comercio) {
    Api.getCsvCodigos(body)
      .then(response => {
        const fechaActual = new Date();
        let comercioNombre = comercio ? comercio : "TODOS";
        let filename = "CodigosDescuento_" + comercioNombre + `_${fechaActual.getDate() + "-" + (fechaActual.getMonth() + 1) + "-" + fechaActual.getFullYear()}.csv`;
        let binaryData = [];
        binaryData.push(response.data);
        let downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: 'text/csv' }));
        downloadLink.setAttribute('download', filename);
        document.body.appendChild(downloadLink);
        downloadLink.click();
      })
      .catch(error => {
        console.log(error.response);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error.response.data.mensaje.message
        });
      })
  }
}
